import { CatalogBrandState } from '@marketplace-web/catalog/catalog-data'

import { initialCatalogBrandState } from '../catalog-initial-state'

import { CatalogBrandReducerAction, CatalogBrandAction } from './actionTypes'

export const catalogBrandReducer = (
  state: CatalogBrandState,
  action: CatalogBrandAction,
): CatalogBrandState => {
  switch (action.type) {
    case CatalogBrandReducerAction.SET_CATALOG_BRAND: {
      const { brand } = action.payload

      return {
        ...state,
        brand,
      }
    }
    case CatalogBrandReducerAction.REMOVE_CATALOG_BRAND: {
      return {
        ...state,
        ...initialCatalogBrandState,
      }
    }
    default:
      return state
  }
}
